import { useEffect, useState } from "react";
import { genreList } from "@/mocks/siteContent";

interface GenreExploreProps {
  activeGenre: string;
  onSelectGenre: (genre: string) => void;
}

export default function GenreExplore({ activeGenre, onSelectGenre }: GenreExploreProps) {
  const [visibleCount, setVisibleCount] = useState(8);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    setVisibleCount(showAll ? genreList.length : 8);
  }, [showAll]);

  const visible = genreList.slice(0, visibleCount);

  return (
    <section id="genres" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm font-medium text-accent-700">按类型浏览</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              从题材偏好出发，快速定位想看的影片
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            点击任意类型卡片即可跳转到影视库，并按该题材自动筛选结果。悬疑、古装、治愈、热血……总有一款适合今晚。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {visible.map((genre) => {
            const isActive = activeGenre === genre.name;
            return (
              <button
                key={genre.name}
                type="button"
                onClick={() => onSelectGenre(genre.name)}
                className={`flex flex-col items-start gap-3 rounded-lg border p-4 text-left transition-colors duration-300 md:p-5 ${
                  isActive
                    ? "border-primary-400 bg-primary-50"
                    : "border-background-200 bg-background-100 hover:border-primary-300 hover:bg-background-200/60"
                }`}
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className={`${genre.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-base font-bold text-foreground-950">{genre.name}</span>
                <span className="text-xs leading-relaxed text-foreground-600">{genre.description}</span>
                <span className="mt-1 text-xs font-medium text-accent-700">{genre.count} 部资源</span>
              </button>
            );
          })}
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setShowAll((v) => !v)}
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-foreground-950"
          >
            <i className={showAll ? "ri-arrow-up-s-line" : "ri-add-line"}></i>
            {showAll ? "收起部分类型" : "展开全部类型"}
          </button>
        </div>
      </div>
    </section>
  );
}